import {
  Component,
  EventEmitter,
  Output,
  ChangeDetectionStrategy,
  input,
} from '@angular/core';

/**
 * @deprecated Do not add new instances of this component. Use 'ag1-pill' instead.
 */
@Component({
  selector: 'ag-pill',
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PillComponent {
  readonly value = input<any>(undefined);
  readonly label = input<string>(undefined);
  readonly canRemove = input<boolean>(undefined);
  @Output()
  remove = new EventEmitter<any>();

  constructor() {}

  handleRemoveClicked() {
    this.remove.emit(this.value());
  }
}
